import { render } from "./AdminTeam.vue?vue&type=template&id=61daa62e&scoped=true&ts=true"
import script from "./AdminTeam.vue?vue&type=script&lang=ts"
export * from "./AdminTeam.vue?vue&type=script&lang=ts"

import "./AdminTeam.vue?vue&type=style&index=0&id=61daa62e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61daa62e"]])

export default __exports__